import logo from './logo.svg';
import './App.css';
import Mainroute from './routes/Mainroute'
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { initializeParse } from '@parse/react';

import {
  QueryClientProvider,
} from 'react-query'

import "primereact/resources/themes/bootstrap4-light-blue/theme.css"    //theme
import "primereact/resources/primereact.min.css"                    //core css
import "primeicons/primeicons.css"                                  //icons
import { queryClient } from './reactQuery';
import { ReactQueryDevtools } from 'react-query/devtools'

initializeParse(
  'http://38.109.112.28:1337/parse',
  'SCWASRTWK9Y6AVMP3KFC',
  'YOUR_JAVASCRIPT_KEY'
);

// Create a client


const App = () =>{
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter >

          <Mainroute />
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>

    </div>
  );
}

export default App;
